export const NO_HIGHLIGHTED_OPTION = -1;

export const getInitialHighlightedOptionIndex = <TOption>(
    options: Array<{ id: string | number }> = [],
    selectedOption?: { id: string | number } | null,
) => {
    if (options.length === 0) {
        return NO_HIGHLIGHTED_OPTION;
    }

    if (!selectedOption) {
        return 0;
    }

    const selectedIndex = options.findIndex(
        (option) => option.id === selectedOption.id,
    );

    return selectedIndex === NO_HIGHLIGHTED_OPTION ? 0 : selectedIndex;
};

export const getNextHighlightedOptionIndex = (
    highlightedOptionIndex: number,
    optionsLength: number,
    direction: 'up' | 'down',
    shouldWrap: boolean = false,
) => {
    if (optionsLength === 0) {
        return NO_HIGHLIGHTED_OPTION;
    }

    const offset = direction === 'down' ? 1 : -1;
    const startIndex =
        highlightedOptionIndex === NO_HIGHLIGHTED_OPTION
            ? 0
            : highlightedOptionIndex;

    const nextIndex = startIndex + offset;

    if (shouldWrap) {
        return (nextIndex + optionsLength) % optionsLength;
    }

    // Stop at boundaries when not wrapping
    if (nextIndex < 0) {
        return 0;
    }
    if (nextIndex >= optionsLength) {
        return optionsLength - 1;
    }

    return nextIndex;
};

export const getSelectableOptionIndex = (
    highlightedOptionIndex: number,
    optionsLength: number,
) => {
    if (optionsLength === 0) {
        return NO_HIGHLIGHTED_OPTION;
    }

    return highlightedOptionIndex === NO_HIGHLIGHTED_OPTION
        ? 0
        : highlightedOptionIndex;
};
